import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

const isPreview =
  typeof window !== 'undefined' &&
  (window.location.pathname === '/preview' ||
    window.location.pathname.startsWith('/preview/'));

const RootApp = React.lazy(() =>
  isPreview ? import('./App') : import('./legacy/App')
);

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <RootApp />
    </Suspense>
  </React.StrictMode>
);
